module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_pegging_choice")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器一覧"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n         件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("選択")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b66b4e5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0040_certificate_information_pegging_choice.vue
// module id = 952
// module chunks = 0